// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill';
import Vue from 'vue';
import 'normalize.css';
import ElementUI from 'element-ui';
import VueClipboard from 'vue-clipboard2';
import socketio from 'socket.io-client';

var VueScrollTo = require('vue-scrollto');
var VueAffix = require('vue-affix');
import { GemPlugin } from './common/gemPlugin';
import VueAwesomeSwiper from 'vue-awesome-swiper';
import 'element-ui/lib/theme-chalk/index.css';
import 'swiper/dist/css/swiper.css';
import store from './store';
import App from './App';
import router from './router';
import filters from './filter/index';
import htmlOptions from '../config/html';

Object.keys(filters).forEach(k => Vue.filter(k, filters[k]));
Vue.config.productionTip = false;
Vue.use(VueAffix);
Vue.use(VueClipboard);
Vue.use(ElementUI);
Vue.use(GemPlugin);
Vue.use(VueAwesomeSwiper);
Vue.use(VueScrollTo);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: {
    App
  }
});



// WEBPACK FOOTER //
// ./src/main.js